import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AppLayout from "../components/AppLayout";
import { api, formatApiError } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import { useAuth } from "../contexts/AuthContext";

export default function Invoices() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [paying, setPaying] = useState(null);
  const fetchAll = () => api.get("/invoices").then((r) => setItems(r.data));
  useEffect(() => { fetchAll(); }, []);

  const pay = async (id) => {
    setPaying(id);
    try {
      const { data } = await api.post("/payments/checkout", { invoice_id: id, origin_url: window.location.origin });
      // redirect to Stripe-hosted Checkout in a new tab so the user can come back
      window.location.href = data.url;
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
      setPaying(null);
    }
  };

  return (
    <AppLayout>
      <h1 className="font-heading text-3xl sm:text-4xl font-black">{t("invoices")}</h1>
      <p className="text-zinc-400 mt-2">{t("payments")} powered by Stripe (test mode). 5% platform fee.</p>
      <div className="mt-8 space-y-3" data-testid="invoices-list">
        {items.map((inv) => {
          const incoming = inv.issued_to === user.id;
          return (
            <div key={inv.id} className="pp-card p-5 flex items-center justify-between flex-wrap gap-3" data-testid={`invoice-${inv.id}`}>
              <div>
                <div className="text-xs text-zinc-500 uppercase tracking-wider">{incoming ? "Bill to pay" : "Issued"}</div>
                <div className="font-heading font-bold mt-1">{inv.description || "Invoice"}</div>
                <div className="text-xs text-zinc-500 mt-1">Due: {inv.due_date ? new Date(inv.due_date).toLocaleDateString() : "—"}</div>
              </div>
              <div className="text-right">
                <div className="font-heading text-xl font-bold">{inv.amount} {inv.currency}</div>
                <div className={`text-xs uppercase mt-1 ${inv.status === "paid" ? "text-[#00E676]" : "text-[#FF3B30]"}`}>{inv.status}</div>
                {incoming && inv.status !== "paid" && (
                  <button data-testid={`pay-${inv.id}`} disabled={paying === inv.id} onClick={() => pay(inv.id)} className="pp-btn-primary px-4 py-2 rounded-lg text-sm mt-2">
                    {paying === inv.id ? "..." : t("pay_now")}
                  </button>
                )}
              </div>
            </div>
          );
        })}
        {items.length === 0 && <div className="pp-card p-10 text-center text-zinc-500" data-testid="invoices-empty">{t("no_results")}</div>}
      </div>
    </AppLayout>
  );
}
